import { render, staticRenderFns } from "./certify.vue?vue&type=template&id=c99f7ef2"
import script from "./certify.vue?vue&type=script&lang=js"
export * from "./certify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports